import React, { useEffect, useState } from 'react';
import MaterialTable, { MTableBody } from '@material-table/core';

import { localization, modifyDefaultOptions, tableIconsModified } from '../../../helpers/table';
import { getColumns, getFilters } from './tableBuysHelper';
import MTableHeader from '../../../components/material-table-overrides/MTableHeader';
import MTableFilterRow from '../../../components/material-table-overrides/MTableFilterRow';
import './table.less';
import { History } from '@material-ui/icons';
import BuyProblemsHistoryModal from '../../budget/BuyProblemsHistoryModal';
import ConfirmModal from '../../../components/common/ConfirmModal';
import ModalSendForRevision from '../../../components/common/ModalSendForRevision';
import useAPI from '../../../hooks/useAPI';
import ProgramBuysFooter from './ProgramBuysFooter';

export default function ProgramBuysTableBuys(props) {
  const {
    data, sourceType, reportType, readonly, updateRow, year, strategyType,
  } = props;
  const api = useAPI();

  const [filters, setFilters] = useState({});
  const [buyProblemsModal, setBuyProblemsModal] = useState(null);
  const [otherProblemModal, setOtherProblemModal] = useState(null);
  const [commentModal, setCommentModal] = useState(null);
  const [cols, setColumns] = useState([]);

  useEffect(() => {
    setFilters((prev) => {
      const filters = getFilters(data);
      setColumns(getColumns(filters, sourceType, reportType, readonly ? null : { showOtherProblemModal, showCommentModal }, year, strategyType));
      return filters;
    });
  }, [data, year, strategyType]);

  const showOtherProblemModal = (id, num, setProblem) => !readonly && setOtherProblemModal({ buy: { id, num }, setProblem });
  const showCommentModal = (id, comment) => !readonly && setCommentModal({ buy: { id }, comment });

  const handleOtherProblem = async (id, setProblem) => {
    const res = await api.post(`/buys/${id}/problems/other`, { id, setProblem });
    setOtherProblemModal(null);
    if (!res.error) {
      const newData = {
        otherProblem: setProblem,
        hasProblem: res.length > 0 ? 'Да' : 'Нет',
        problemDescr: res.map((r) => r.buyProblemTypeDescr).join(', \n'),
      };
      if (newData.hasProblem === 'Нет') newData.problemComment = null;
      updateRow(id, newData);
    }
  };
  const handleSaveComment = async (id, comment) => {
    const res = await api.post(`/buys/${id}/comments`, { id, comment });
    setCommentModal(null);
    if (!res.error) {
      updateRow(id, { problemComment: res.message });
    }
  };

  return (
    <div className="wrapper">
      <MaterialTable
        title={null}
        data={data}
        columns={cols}
        localization={localization}
        options={modifyDefaultOptions({
          search: false,
          draggable: false,
          toolbar: false,
          maxBodyHeight: 'calc(100vh - 450px)',
          filterCellStyle: {
            position: 'sticky',
            top: 79,
            background: 'white',
            zIndex: 5,
          },
        })}
        icons={tableIconsModified}
        actions={readonly ? null : [
          (rowData) => ({
            custom: true,
            icon: () => <History style={{ color: '#0D6EFD' }} />,
            tooltip: 'История версий',
            onClick: (e, data) => {
              setBuyProblemsModal({
                id: rowData.id,
                num: rowData.num,
                version: rowData.version,
                // projId: rowData.projId,
              });
            },
          }),
        ]}
        components={{
          Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky} />),
          FilterRow: (props) => (<MTableFilterRow {...props} />),
          Body: (_props) => (
            <>
              <MTableBody {..._props} />
              <ProgramBuysFooter {..._props} readonly={readonly} />
            </>
          ),
        }}
      />
      {buyProblemsModal && <BuyProblemsHistoryModal buy={buyProblemsModal} onClose={() => setBuyProblemsModal(null)} />}
      <ConfirmModal
        show={otherProblemModal}
        onClose={() => setOtherProblemModal(null)}
        onConfirm={() => handleOtherProblem(otherProblemModal.buy.id, otherProblemModal.setProblem)}
        headerText={`${otherProblemModal?.setProblem ? 'Добавить' : 'Решить'} иную проблему`}
        message={otherProblemModal?.setProblem
          ? `Закупке ${otherProblemModal?.buy.num} будет добавлена пометка об иной проблеме. Добавить иную проблему?`
          : `Иная проблема у закупки ${otherProblemModal?.buy.num} решена?`}
      />
      <ModalSendForRevision
        show={commentModal}
        onSubmit={(comment) => handleSaveComment(commentModal?.buy.id, comment)}
        onClose={() => setCommentModal(null)}
        headerText="Изменение комментария по закупке"
        label="Комментарий"
        defaultText={commentModal?.comment ?? ''}
      />
    </div>
  );
}

const styledHeaderSticky = { position: 'sticky', top: 0, zIndex: 10 };
